//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    carouselSlides: Array
  },
  data () {
    return {
      polling: null,
      isLoadedDesktop: false,
      isLoadedMobile: false
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  // Start polling on the client only. In `created()` this runs during SSR too,
  // where `beforeDestroy` never fires — so the interval (and the whole
  // component/$store/$apolloProvider graph it closes over) leaks on every
  // server render. `mounted()` is client-only and pairs with `beforeDestroy`.
  // The interval also manipulates `this.$refs`, which only exist client-side.
  mounted () {
    this.pollData()
  },
  methods: {
    pauseCarousel () {
      clearInterval(this.polling)
      this.pollData()
    },
    pollData () {
      this.polling = setInterval(() => {
        for (let counter = 1; counter <= 5; counter++) {
          let myElement = this.$refs['radio' + counter]
          if (myElement && myElement.checked) {
            counter++
            if (counter > 5) {
              counter = 1
            }
            myElement = this.$refs['radio' + counter]
            if (myElement) {
              myElement.checked = true
            }
            break
          }
        }
      }, 6500)
    },
    onImgLoadDesktop () {
      this.isLoadedDesktop = true
    },
    onImgLoadMobile () {
      this.isLoadedMobile = true
    }
  },
  computed: {
    isLoaded () {
      return this.isLoadedDesktop && this.isLoadedMobile
    }
  }
}

